/**
 * The request types that change a person's per-provider allocation, one per tier (`AIA-81`): A reallocates
 * allowance between providers that stay on, B switches a provider off, and C switches on a provider the person
 * did not have on before. Mirrors `Rws.AiInsights.Entitlement.Requests.RequestTypes.ProviderAllocationKinds`.
 */
export const providerAllocationRequestTypes = ["ProviderReallocation", "ProviderDisable", "ProviderEnable"] as const;

/** Whether a request type is one of the provider-allocation tiers. */
export function isProviderAllocationRequest(requestType: string): boolean {
  return (providerAllocationRequestTypes as readonly string[]).includes(requestType);
}
